import { Divider } from "primereact/divider"
import { useState } from "react"
import Logo from "../../components/Logo/Logo"

export const Footer = ({ dataSite }) => {

    const [showInformation, setShowInformation] = useState(false)
    console.log(dataSite)
    return (
        <div className="grid justify-content-center mt-6 lg:px-8 w-full px-4 sm:px-0">
            <div className="col-12 md:col-7 flex flex-column justify-content-between">
                {dataSite?.company?.indexOf('OOO') === -1 && <div className="phones">
                    <h5 className="my-1">Служба заботы</h5>
                    <div className="flex flex-column md:flex-row my-3">
                        <div className="flex md:mr-5 lg:mr-8">
                            <img className="mr-2" src="/assets/RU.svg" alt="" />
                            <a href="tel:74951339689" className="my-1">
                                + 7 495 133 96-89
                            </a>
                        </div>
                        <div className="flex">
                            <img className="mr-2" src="/assets/UA.svg" alt="" />
                            <a href="tel:3800443346937" className="my-1">
                                +380 044 334 69-37
                            </a>
                        </div>
                    </div>

                    <p className="my-1">mail@ashahov.ru</p>
                </div>
                }
                <div className="flex align-items-center information-title mt-5" onClick={() => setShowInformation(!showInformation)}>
                    <p className="mr-3">Правовая информация</p>
                    <img src={`/assets/${showInformation ? 'up' : 'down'}.svg`} alt="" />
                </div>
                {showInformation && (
                    <div className="information">
                        <div className="mt-5 rights">
                            {dataSite?.company.indexOf('OOO') === -1 &&
                                <p className="mt-0 mb-4">Александр Шахов © 2022.</p>}
                            {dataSite?.company.indexOf('OOO') > -1 &&
                                <p className="mt-0 mb-4">ООО «ИСП Александра Шахова» © 2022.</p>}
                            <p className="mt-0 mb-4 gray">Все права защищены</p>
                            <p className="my-0">Все материалы курсов являются интеллектуальной собственностью, охраняются Законом об авторском праве, предназначены только для личного использования и не подлежат передаче третьим лицам.</p>
                            <p>Копирование, тиражирование и коммерческое использование без разрешения автора запрещены.</p>
                        </div>
                        <Divider className="line-footer" />
                        <div className="made_in mt-5">
                            <p className="mb-3">Продукция произведена на территории Российской Федерации</p>
                            <p className="mt-0 mb-3">Products made in the Russian Federation</p>
                        </div>
                        <Divider className="line-footer" />
                        <div className="requisites my-5">
                            {dataSite?.company.indexOf('OOO') === -1 &&
                                <>
                                    <p className="my-0">ИП Шахов Александр Алексеевич</p>
                                    <p className="my-3">
                                        ОРГНИП <span>317144700020548</span>
                                    </p>
                                    <p className="my-0">
                                        ИНН <span>410110105050</span>
                                    </p>
                                </>
                            }
                            {dataSite?.company.indexOf('OOO') > -1 &&
                                <>
                                    <p className="my-0">Общество с ограниченной ответственностью «Институт социальной психологии Александра Шахова»</p>
                                    <p className="my-3">
                                        ОРГНИП <span>1217700416240</span>
                                    </p>
                                    <p className="my-0">
                                        ИНН <span>9705159075</span>
                                    </p>
                                </>
                            }

                        </div>
                    </div>
                )}
            </div>

            <div className="col-12 md:col-5 flex justify-content-start md:justify-content-end">
                <div className="links">
                    {dataSite?.company?.indexOf('OOO') === -1 &&
                        <>
                            <div>
                                <a href="https://tl.ashahov.ru/public_offer" rel="noreferrer" target='_blank'>Договор-оферта</a>
                            </div>
                            <div>
                                <a href="/assets/docs/conf.pdf" rel="noreferrer" target='_blank'>Положение о конфиденциальности</a>
                            </div>
                            <div>
                                <a href="/assets/docs/adv.pdf" rel="noreferrer" target='_blank'>Согласие на получение рекламы</a>
                            </div>
                            <div>
                                <a href="/assets/docs/extention_conditions.pdf" rel="noreferrer" target='_blank'>Условия продления доступа к курсам</a>
                            </div>
                        </>
                    }

                    {dataSite?.company === 'OOO_CONF' &&
                        <>
                            <div>
                                <a href="/assets/docs/offer_conf.pdf" rel="noreferrer" target='_blank'>Договор-оферта</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/privacy" rel="noreferrer" target='_blank'>Положение о конфиденциальности</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/ad-agreement" rel="noreferrer" target='_blank'>Согласие на получение рекламы</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/pravila_vozvrata" rel="noreferrer" target='_blank'>Условия продления доступа к курсам</a>
                            </div>
                        </>
                    }

                    {dataSite?.company === 'OOO' &&
                        <>
                            <div>
                                <a href="https://ippshahov.com/public/offer" rel="noreferrer" target='_blank'>Договор-оферта</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/privacy" rel="noreferrer" target='_blank'>Положение о конфиденциальности</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/ad-agreement" rel="noreferrer" target='_blank'>Согласие на получение рекламы</a>
                            </div>
                            <div>
                                <a href="https://ippshahov.com/public/pravila_vozvrata" rel="noreferrer" target='_blank'>Условия продления доступа к курсам</a>
                            </div>
                        </>
                    }

                    <div className="flex md:hidden label justify-content-center md:justify-content-start">
                        <Logo data={dataSite} />
                    </div>
                </div>
            </div>
        </div>
    )
}